var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H1V2H16V0Z",
    fill: "black",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11H16V10H17V8L16 3H1L0 8V10H1V16H10V10H14V11ZM8 14H3V10H8V14ZM2 8L2.6 5H14.36L14.96 8H2Z",
    fill: "black",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.864 15C20.8603 14.8311 20.8442 14.6626 20.816 14.496L21.728 13.696L20.928 12.312L19.768 12.704C19.5111 12.4876 19.2188 12.3171 18.904 12.2L18.664 11H17.064L16.824 12.192C16.5092 12.3091 16.2169 12.4796 15.96 12.696L14.8 12.304L14 13.688L14.912 14.488C14.8838 14.6546 14.8677 14.8231 14.864 14.992C14.8677 15.1609 14.8838 15.3294 14.912 15.496L14 16.296L14.8 17.68L15.96 17.288C16.2169 17.5044 16.5092 17.6749 16.824 17.792L17.064 19H18.664L18.904 17.808C19.2188 17.6909 19.5111 17.5204 19.768 17.304L20.928 17.696L21.728 16.312L20.816 15.512C20.8446 15.3428 20.8607 15.1716 20.864 15V15ZM17.864 16.6C17.5475 16.6 17.2382 16.5062 16.9751 16.3304C16.712 16.1545 16.5069 15.9047 16.3858 15.6123C16.2647 15.3199 16.233 14.9982 16.2947 14.6879C16.3565 14.3775 16.5089 14.0924 16.7326 13.8686C16.9564 13.6449 17.2415 13.4925 17.5519 13.4307C17.8622 13.369 18.1839 13.4007 18.4763 13.5218C18.7687 13.6429 19.0185 13.848 19.1944 14.1111C19.3702 14.3742 19.464 14.6835 19.464 15C19.464 15.4243 19.2954 15.8313 18.9954 16.1314C18.6953 16.4314 18.2883 16.6 17.864 16.6Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationNew);
export default __webpack_public_path__ + "static/media/location-new.2ba1ec0c.svg";
export { ForwardRef as ReactComponent };